// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__64CoW","icon":"SortAdornment_icon__1vP3p","up":"SortAdornment_up__2Gr_R","down":"SortAdornment_down__RZIOP","active":"SortAdornment_active__2ARPG"};